Controller = App.loadClass 'core::Angular/Controller'

class exports.TableViewController extends Controller
    constructor: (@scope, @transitions, @rxLayer) ->
        super

        @scope.rx = @rxLayer.data
        @scope.resize_table = 0
        @scope.changeRowBrand = @changeRowBrand
        @scope.averagePop = @rxLayer.averagePop
        @scope.changeTruthStripPopulation = @changeTruthStripPopulation
        @scope.savePopulations = @savePopulations
        @scope.close = @close

        @scope.hasLayer = (name) =>
            for layer in @scope.rx.visual_layers
                return true if layer.name is name or layer.type is name
            return false

        # used to eliminate polygons with 0.0 to 0.1 acres, which are usually
        # just tiny fragments resulting from imprecise cross-cropping
        # See https://www.pivotaltracker.com/story/show/136900033
        @scope.filterTinyPolygons = (polygon) ->
            return polygon.acres > 0.1

        # When we change the literal actual populations array,
        # meaning we recalculated, ensure the table sizing is right.
        @scope.$watch 'rx.populations', () =>
            @scope.resize_table++

        # Non-deep watch to update truth strip defaults whenever recalc runs
        @scope.$watch 'rx.populations', @setTruthStripDefaults



    # Sets up the truth strip rows. We have to handle truth strips kinda weird.
    # Here's the deal:
    #
    #   - We have truth strips stored in rx.truth_strips. This is where they're
    #       stored after we first draw them. They are stored *per strip*
    #   - We have truth strip data stored amongst the rx.populations data. This
    #       data is stored *per polygon*. Since a truth strip may cross multiple
    #       polygons of the underlying layers, we will potentially have multiple
    #       polygons for ONE truth strip.
    #   - We want to display data in the table *per strip*, not *per polygon*, but
    #       we must be able to update the individual polygons still.
    #   - In order to achieve all this, we'll copy population / hybrid selection
    #       from the polygon level to the strip level, then use some watches and
    #       ng-change's to support filling the data back to the polygon level
    #
    setTruthStripDefaults: () =>
        for strip, index in @scope.rx.truth_strips
            # For new (or recalculated) polygons, the strip id is
            # a fake, purely incremental number. For polygons retrieved from
            # the DB, we use the strip.real_strip_id
            # strip.strip_id = index
            polys = @rxLayer.getStripPolygons(strip)
            continue if not polys or polys.length is 0

            strip.population = polys[0].population ? @scope.averagePop()
            if not polys[0].population
                @changeTruthStripPopulation(strip)

            # set the acres
            acres = 0
            acres += parseFloat(poly.acres) for poly in polys
            strip.acres = acres.toFixed(2)

            strip.fillColor = polys[0].fillColor
            strip.display_id = polys[0].display_id
            strip.temp_hybrids_id = polys[0].hybrids_id
            strip.temp_hybrid_name = polys[0].hybrid_name



    # When we switch the hybrid for a particular population row, we need to update
    # it's "name" as well. This is because we're not using proper object selection
    # for this portion.
    #
    # This is somewhat lamentable (because it means we have to do things like this!),
    # but leaving the data in the structure it is currently in simplifies interop
    # with the rest of the rx process.
    changeRowBrand: (row, truth_strip = false) =>
        h = _.filter @scope.rx.planting_selections, { brand: id: row.temp_hybrids_id }

        row.temp_hybrid_name = h[0].brand.name if h.length > 0

        return if not truth_strip

        strips = @rxLayer.getStripPolygons(row)
        for strip in strips
            strip.temp_hybrids_id = row.temp_hybrids_id
            strip.temp_hybrid_name = row.temp_hybrid_name


    changeTruthStripPopulation: (row) =>
        strips = @rxLayer.getStripPolygons(row)

        for strip in strips
            strip.temp_population = row.population


    # Table View uses temp population values, so we'll sync everything
    # back up so that the populations we entered will be actually saved.
    savePopulations: () =>
        # Adjust first truth strip to reflect the possibly new avg pop
        if @scope.rx.truth_strips.length > 0
            row = @scope.rx.truth_strips[0]
            row.population = @scope.averagePop(true)
            @changeTruthStripPopulation row

        for pop in @scope.rx.populations
            pop.population = pop.temp_population
            pop.orig_population = parseInt pop.temp_population
            pop.hybrids_id = pop.temp_hybrids_id
            pop.hybrid_name = pop.temp_hybrid_name
        @scope.tableForm.$setPristine()

    # Close the dialog and reset the "temp_" values
    close: () =>
        for pop in @scope.rx.populations
            pop.temp_population = pop.population
            pop.temp_hybrids_id = pop.hybrids_id
            pop.temp_hybrid_name = pop.hybrid_name

        @setTruthStripDefaults()
        @scope.tableForm.$setPristine()

        @scope.$parent.$parent.show_fullpage = false

